import React, { useEffect, useState } from "react"
import "../blog/blog.css"
import { blog } from "../../dummydata"
import Heading from "../common/heading/Heading"
import api from "../api"
import { BASE_URL } from "../common/constants"

// copy code of blog => blogCard

const Hblog = () => {

  const [branches,setBranches]=useState([])
  const getBranches = async () => {

    try{
    const resp = await api.get(`/api/v1/branches`);
    setBranches(resp?.data?.rows)  
    }catch(error){
      console.log("error",error)
    }
  }
  useEffect(()=>{
    getBranches()
  },[])
  return (
    <>
      <section className='blog'>
        <div className='container'>
          <Heading subtitle='OUR Branches' title='Branches of Al-Munir Educational System' />
          <div className='grid2'>
            {/* {blog.slice(0, 3).map((val) => (
              <div className='items shadow'>
                <div className='img'>
                  <img src={val.cover} alt='' />
                </div>
                <div className='text'>
                  <div className='admin flexSB'>
                    <span>
                      <i className='fa fa-user'></i>
                      <label htmlFor=''>{val.type}</label>
                    </span>
                    <span>
                      <i className='fa fa-calendar-alt'></i>
                      <label htmlFor=''>{val.date}</label>
                    </span>
                    <span>
                      <i className='fa fa-comments'></i>
                      <label htmlFor=''>{val.com}</label>
                    </span>
                  </div>
                  <h1>{val.title}</h1>
                  <p>{val.desc}</p>
                </div>
              </div>
            ))} */}
            {branches.map((val) => (
              <div className='items shadow'>
                <div className='img'>
                  <img src={ BASE_URL +
                          '/' +val.logo}alt='Branch Logo' />
                </div>
                <div className='text'>
                  <div className='admin flexSB'>
  </div>
                  <h1>{val.name}</h1>
                  <span>
                      <i className='fa fa-user'></i>
                      <label htmlFor=''>{val.principleName}</label>
                    </span>
                    <div>

                    <span>
                      <i className='fa fa-book'></i>
                      <label htmlFor=''>{val.principleEducation}</label>
                    </span>
                    </div>
                    <div>

                    <span>
                      <i className='fa fa-map-marker'></i>
                      <label htmlFor=''>{val.address}</label>
                    </span>
                    </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  )
}

export default Hblog
